/*global _, $$re, $ */
import {querySelectorAsync} from './dom'
import {onWindowResize} from './utils'
import {ready} from './addiesaas'

export const instances = {}
export const rootInstances = {}
const COMPONENT_OPTIONS = {strict: false, preloader: false}

export const destroy = function (name, root = true) {
  const instance = instances[name]
  if (instance) {
    if (instance.$el) {
      instance.$el.remove()
    }
    if (instance.$destroy) {
      instance.$destroy()
    }
    delete instances[name]
  }
  if (root) {
    const rootInstance = rootInstances[name]
    if (rootInstance) {
      if (rootInstance.$el) {
        rootInstance.$el.remove()
      }
      if (rootInstance.$destroy) {
        rootInstance.$destroy()
      }
      delete rootInstances[name]
    }
  }
}

export const getComponentOptions = (item, name) => {
  item = item || {}
  const {component, componentOptions = {}} = item
  name = name || (component + '-' + (new Date()).valueOf())

  const options = {
    ...COMPONENT_OPTIONS,
    ...componentOptions
  }

  if (name) {
    const {rendered: _rendered} = options
    options.rendered = async function (i, params) {
      instances[name] = i
      rootInstances[name] = this

      await i.$nextTick()
      if (_.isFunction(item.rendered)) {
        item.rendered.call(this, i, item, params)
      }
      if (_.isFunction(_rendered)) {
        _rendered.call(this, i, item, params)
      }
      await componentRendered.call(this, i, item, params)
    }
  }

  return options
}

export const createParent = async (targetDef) => {
  const {
    targetSelector,
    root,
    element,
    method,
    container,
    containerElement,
    containerMethod
  } = targetDef

  let target = await querySelectorAsync(targetSelector)
  let $target = $(target)
  if (container) {
    let containerElm = $target.find(container)
    if (!containerElm.length) {
      containerElm = $(containerElement)[containerMethod]($(target))
    }
    $target = containerElm
  }
  let parent = $target.find(root)
  if (!parent.length) {
    const componentElement = $(element)
    parent = componentElement[method]($target)
  }

  return parent
}

export const create = async (item, name) => {
  const {component, target} = item
  const mainParent = await createParent(target)
  ready(() => {
    $$re('add', component, mainParent, getComponentOptions(item, name))
  })
}

const componentRendered = async function (instance, item, params) {
  const {responsiveTargets: targets = [], responsiveOptions = {}} = item
  if (targets.length) {
    await instance.$nextTick()
    onWindowResize(async ({width}) => {
      const def = _.find(targets, i => width >= i.minWidth) || item.target
      const el = instance.$el
      const elParent = $(el).parent()
      const parent = await createParent(def)
      const parentAlreadyHasComponent = parent.has(el)
      if (!parentAlreadyHasComponent.length) {
        parent.append(el)
        if (responsiveOptions.removeParent) {
          if (!elParent.is(parent)) {
            elParent.remove()
          }
        }
        if (def.remounted) {
          def.remounted.call(this, instance, item, params)
        }
        if (item.remounted) {
          item.remounted.call(this, instance, item, params)
        }
      }
      if (def.onResize) {
        def.onResize.call(this, {width, instance, parent, params, item})
      }
      if (item.onResize) {
        item.onResize.call(this, {width, instance, parent, params, item})
      }
    })
  }
}

export default {
  create,
  destroy,
  instances
}
